import { Component, Input } from '@angular/core';
import { NgFor } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AccessoryCardComponent } from './accessory-card.component';

@Component({
  selector: 'app-vehicle-module',
  standalone: true,
  imports: [NgFor, AccessoryCardComponent, TranslateModule],
  template: `
    <div class="vehicle-module">
      <h2>{{ 'labels.mainVehicle' | translate }}</h2>
      <div *ngFor="let accessory of vehicle?.accessories">
        <app-accessory-card [accessory]="accessory"></app-accessory-card>
      </div>
    </div>
  `
})
export class VehicleModuleComponent {
  @Input() vehicle: any;
}
